<template></template>

<script>
//测试AppId
// const appId = 'wxa9dadd63bb592073';
//正式AppId
const appId = "wxc8cd43c986d767b9";
const urlPrefixNoAdmin = "https://mp.yijugongshe.com"; //正式api地址
//    const urlPrefixNoAdmin = "http://t.szlsyjsq.com"; //测试api地址
export default {
  appId,
  urlPrefixNoAdmin,
};
</script>

<style scoped></style>
